import React from 'react';

/**
 * Responsive grid wrapper for schedule cards (`.schedule-card-grid`).
 */
export const ScheduleCardGrid = ({ children }) => (
  <div className="schedule-card-grid">{children}</div>
);

/**
 * A clickable schedule card (`.schedule-card`). Mirrors the date-card markup
 * from eventPrograms.js / classroom.js.
 *
 * Props:
 *   title
 *   status?    { label, tone: 'open' | 'sold-out' | 'info' }
 *   time?      string
 *   meta?      array of strings -> one .schedule-card-meta line each
 *   preview?   node -> .schedule-card-preview
 *   actionLabel?  footer call-to-action
 *   onClick
 */
export const ScheduleCard = ({ title, status, time, meta = [], preview, actionLabel, onClick }) => (
  <button type="button" className="schedule-card" onClick={onClick}>
    <div className="schedule-card-header">
      <span className="schedule-card-title">{title}</span>
      {status ? (
        <span className={`schedule-card-status ${status.tone || 'info'}`}>{status.label}</span>
      ) : null}
    </div>
    {time ? <div className="schedule-card-time">{time}</div> : null}
    {meta.map((line, index) => (
      <div className="schedule-card-meta" key={index}>
        {line}
      </div>
    ))}
    {preview != null ? <div className="schedule-card-preview">{preview}</div> : null}
    {actionLabel ? <div className="schedule-card-action">{actionLabel}</div> : null}
  </button>
);

/**
 * Dashed empty-state box (`.schedule-empty-state`) for when a list has no items.
 */
export const ScheduleEmptyState = ({ children }) => (
  <div className="schedule-empty-state">{children}</div>
);

export default ScheduleCardGrid;
